import T from 'prop-types';
import React, { useRef, useCallback } from 'react';

import { Input } from './FileUpload.stc';
import { withCheckAuth } from '../../utils/requext';

function FileUpload({
    url,
    accept,
    onClick,
    onError,
    fileType,
    children,
    multiple,
    onChoose,
    onSuccess,
    run = true,
    size = 6,
}) {
    const fileInput = useRef();
    const handleClick = useCallback(
        (e) => {
            if (fileInput.current) {
                fileInput.current.value = '';
                fileInput.current.click();
                onClick(e);
            }
        },
        [onClick]
    );

    const handleChange = useCallback(
        async (e) => {
            onChoose(e);
            const { files } = e.target;
            const fileSize = files[0].size;
            if (size && fileSize > size * 1024 * 1024) {
                return onError('Upload a file under ' + size + 'MB');
            }

            const formData = new FormData();
            formData.append('fileType', fileType);
            formData.append('file', files[0]);

            try {
                const result = await withCheckAuth(url, {
                    body: formData,
                    headers: {},
                });
                onSuccess(result);
            } catch (err) {
                onError(err.message);
            }
            return;
        },
        [onChoose, size, fileType, onError, url, onSuccess]
    );

    if (!run)
        return (
            <p style={{ textAlign: 'center' }}>
                Sign Up or Login to Upload
                <br />
                Or insert a URL below
            </p>
        );
    return (
        <div onClick={handleClick}>
            {children}
            <Input
                type="file"
                accept={accept}
                ref={fileInput}
                onChange={handleChange}
            />
        </div>
    );
}

const fn = () => {};
FileUpload.defaultProps = {
    onSuccess: fn,
    onError: fn,
    onClick: fn,
    onChoose: fn,
};
FileUpload.propTypes = {
    url: T.string,
    multiple: T.bool,
    onSuccess: T.func,
    onError: T.func,
    onClick: T.func,
    onChoose: T.func,
};

export default React.memo(FileUpload);
